export default __webpack_public_path__ + "static/PromptIconOne-8956042f80ad0d2392c95987f4d0418e.png";